function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Divider, FlatList, ScrollView } from 'unitx-ui';
import * as R from 'unitx/ramda';
import { EVENT, ELEMENT_DATA_FIELDS } from "../../../utils/constants";
import { NewTripleItem } from "./NewTripleItem";
import { TripleItem } from "./TripleItem"; // import DataSection from './DataItem'

const DataEditorElement = props => {
  const {
    data,
    onEvent,
    localLabel,
    globalLabel,
    isGlobalLabelFirst
  } = props;
  return /*#__PURE__*/React.createElement(ScrollView, {
    horizontal: true,
    style: {
      width: '100%'
    },
    contentContainerStyle: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(FlatList, {
    data: data,
    style: {
      width: '100%'
    },
    contentContainerStyle: {
      width: '100%'
    },
    renderItem: ({
      item: dataItem,
      index
    }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TripleItem, _extends({}, dataItem, {
      onEvent: (type, extraData) => onEvent({
        extraData,
        index,
        dataItem,
        type
      }),
      isLocalLabel: R.equals(localLabel, [ELEMENT_DATA_FIELDS.DATA, dataItem.name]),
      isGlobalLabel: R.equals(globalLabel, [ELEMENT_DATA_FIELDS.DATA, dataItem.name]),
      isGlobalLabelFirst: isGlobalLabelFirst
    })), /*#__PURE__*/React.createElement(Divider, null)),
    ListFooterComponent: /*#__PURE__*/React.createElement(NewTripleItem, {
      onAdd: dataItem => onEvent({
        type: EVENT.ADD_DATA,
        extraData: dataItem
      })
    })
  }));
};

export const DataEditor = DataEditorElement; // wrapComponent<DataEditorProps>(
//   DataEditorElement,
//   {},
// ) as typeof DataEditorElement